import React, { useContext } from "react";
import styles from "./BTSCarousel.module.css";
import Carou from "../OSPCarousel/Carou"; // Adjust the path if necessary
import { LanguageContext } from '../LanguageContext/LanguageContext';

const BTSCarousel = ({ sixthData }) => {
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';

  if (!sixthData) return <p>Loading...</p>; // Handle loading state

  // Use sixthData for title and mediaContent
  const title = isRTL ? sixthData.titleInArab : sixthData.titleInEng;
  const mediaContent = sixthData.mediaContent || [];

  // Prepare items for Carou
  const carouItems = mediaContent.map((content, index) => ({
    id: index,
    content: (
      <div className={styles.card}>
        <a href={content.instagramLink} target="_blank" rel="noopener noreferrer">
          <img src={`${content.imageUrl}`} alt={content.title} className={styles.videobook} style={{height:"100%", width:"100%"}} />
          <p className={styles.description}>
            {isRTL ? content.description : content.other}
          </p>
        </a>
      </div>
    ),
  }));

  return (
    <div className={styles.carouselcontainer}>
      <h2>{title}</h2>
      <div className={styles.carousel}>
        <Carou
          itemWidth={465} // Adjust based on your design
          itemHeight={720} // Adjust based on your design
          items={carouItems}
          scalingRatio={1.3} // Control the scaling of the center item
          margin={0} // Space between items
        />
      </div>
    </div>
  );
};

export default BTSCarousel;
